export const SEND_ITEMS = "send-items";
export const SEND_TO_MYSELF = "send-to-myself";
export const SEND_TO_OTHERS = "send-to-others";

export const SEND_ITEMS_SELECTION_OPTINS = {
  [SEND_TO_MYSELF]: {
    key: SEND_TO_MYSELF,
    value: SEND_TO_MYSELF,
    label: "Shop for Myself",
  },
  [SEND_TO_OTHERS]: {
    key: SEND_TO_OTHERS,
    value: SEND_TO_OTHERS,
    label: "Send items to Others",
  },
};
